import Resources from "../../shared/actions/resourcesActions";

class RoomBookPrototypeResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "room_book_prototype", "/api/v1/room_book_prototypes");
  }
}

export default RoomBookPrototypeResource;
